export default __webpack_public_path__ + "static/test-tutorial-es-a8e538bb6fa815401c794882110fb0ac.mp4";